import { render, staticRenderFns } from "./KnTaxInfo.vue?vue&type=template&id=4ebe30d0&"
import script from "./KnTaxInfo.vue?vue&type=script&lang=js&"
export * from "./KnTaxInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports